import { VesselHistory } from '@/types/api';
// maplibregl loaded via CDN script, types use 'any' to avoid import.meta build errors
type MapInstance = any;

import { create } from 'zustand';

interface OverlaysSettings {
  labels: boolean;
  seaMark: boolean;
  marineTraffic: boolean;
  windyMap: boolean;
  ports: boolean;
  showPortBySystem: boolean;
}

interface MeteorologySettinggs {
  clouds: boolean;
  precipitation: boolean;
  rain: boolean;
  pressure: boolean;
  pressureCountour: boolean;
  temperature: boolean;
  wind: boolean;
  temp: boolean;
}

interface MapsGLStore {
  maps: MapInstance | null;
  canvasLayer: any;
  setMaps: (maps: MapInstance | null) => void;
  setCanvasLayer: (canvasLayer: any) => void;
  savedCenter: [number, number];
  savedZoom: number;
  setSavedCenter: (center: [number, number]) => void;
  setSavedZoom: (zoom: number) => void;
  overlaysSettings: OverlaysSettings;
  meteorologySettings: MeteorologySettinggs;
  setOverlaysSettings: (key: string, value: boolean) => void;
  setMeteorologySettings: (key: string, value: boolean) => void;
  markersRouteRef: any[];
  setMarkersRouteRef: (markersRouteRef: any[]) => void;
  routesRef: any;
  setRoutsRef: (routesRef: any) => void;
  polylineRef: any[];
  setPolylineRef: (polylineRef: any[]) => void;
  polylineRouteData: any[];
  setPolylineRouteData: (polylineRouteData: any[]) => void;
  polylineAnimationRef: any[];
  setPolylineAnimationRef: (polylineRef: any[]) => void;
  vesselAnimationMarkerRef: any | null;
  setVesselAnimationMarkerRef: (vesselAnimationMarkerRef: any | null) => void;
  cleanRoutes: () => void;
  modalOpenVesselConfiguration: boolean;
  modalMinimizedVesselConfiguration: boolean;
  setModalOpenVesselConfiguration: (modalOpenVesselConfiguration: boolean) => void;
  setModalMinimizedVesselConfiguration: (modalMinimizedVesselConfiguration: boolean) => void;
  toggleModalOpenVesselConfiguration: () => void;
  isMapsLayerOpen: boolean;
  setMapsLayerOpen: (isOpen: boolean) => void;
  toggleMapsLayerOpen: () => void;
  modalMinimizedMapsLayer: boolean;
  setModalMinimizedMapsLayer: (modalMinimizedMapsLayer: boolean) => void;
  etaDestinationMarkerRef: any | null;
  setEtaDestinationMarkerRef: (ref: any | null) => void;
  etaOriginMarkerRef: any | null;
  setEtaOriginMarkerRef: (ref: any | null) => void;
  cleanEtaPredictionRoute: () => void;
}

const getInitialWindyMap = (): boolean => {
  return false;
};

const useMapsGLStore = create<MapsGLStore>((set, get) => ({
  //@ts-ignore
  maps: null,
  setMaps: (maps) => {
    console.log("useMapsStore: setMaps called with maps truthy?:", !!maps);
    set({ maps: maps });
  },
  canvasLayer: null,
  setCanvasLayer: (canvasLayer) => set({ canvasLayer: canvasLayer }),
  savedCenter: [-3.316694, 114.590111],
  savedZoom: 6,
  setSavedCenter: (center) => set({ savedCenter: center }),
  setSavedZoom: (zoom) => set({ savedZoom: zoom }),
  overlaysSettings: {
    labels: true,
    seaMark: false,
    marineTraffic: false,
    windyMap: getInitialWindyMap(),
    ports: false,
    showPortBySystem: false,
  },
  meteorologySettings: {
    clouds: false,
    precipitation: false,
    rain: false,
    pressure: false,
    pressureCountour: false,
    temperature: false,
    wind: false,
    temp: false,
  },
  setOverlaysSettings: (key, val) => {
    set((state) => ({
      overlaysSettings: {
        ...state.overlaysSettings,
        [key]: val,
      },
    }));
  },
  setMeteorologySettings: (key, val) => {
    set((state) => ({
      meteorologySettings: {
        ...state.meteorologySettings,
        [key]: val,
      },
    }));
  },

  /**
   * @description
   * Detail marker state
   */

  markersRouteRef: [],
  setMarkersRouteRef: (markersRouteRef) => set(() => ({ markersRouteRef: markersRouteRef })),
  routesRef: null,
  setRoutsRef: (routesRef) => set(() => ({ routesRef: routesRef })),
  polylineRef: [],
  setPolylineRef: (polylineRef) => set(() => ({ polylineRef: polylineRef })),
  polylineRouteData: [],
  setPolylineRouteData: (polylineRouteData) =>
    set(() => ({ polylineRouteData: polylineRouteData })),
  polylineAnimationRef: [],
  setPolylineAnimationRef: (polylineRef) => set(() => ({ polylineAnimationRef: polylineRef })),
  vesselAnimationMarkerRef: null,
  setVesselAnimationMarkerRef: (vesselAnimationMarkerRef) =>
    set(() => ({ vesselAnimationMarkerRef: vesselAnimationMarkerRef })),
  cleanRoutes: () => {
    const {
      maps,
      routesRef,
      polylineRef,
      markersRouteRef,
      polylineAnimationRef,
      vesselAnimationMarkerRef,
      setMarkersRouteRef,
      setPolylineRef,
      setPolylineRouteData,
      setRoutsRef,
      canvasLayer,
    } = get();

    if (!maps) return;

    const safeRemove = (ref: any) => {
      if (!ref) return;
      if (typeof ref === 'string') {
        const trimmed = ref.trim();
        if (trimmed !== '' && typeof maps.getLayer === 'function') {
          try {
            if (maps.getLayer(trimmed)) maps.removeLayer(trimmed);
          } catch (e) {
            // ignore
          }
        }
      } else if (Array.isArray(ref)) {
        ref.forEach((item) => safeRemove(item));
      } else if (typeof ref === 'object') {
        if (typeof ref.remove === 'function') {
          try {
            ref.remove();
          } catch (e) {
            // ignore
          }
        } else if (typeof maps.removeLayer === 'function') {
          try {
            maps.removeLayer(ref);
          } catch (e) {
            // ignore
          }
        }
      }
    };

    try {
      if (typeof maps.getLayer === 'function') {
        if (maps.getLayer('routes-layer')) maps.removeLayer('routes-layer');
        if (maps.getLayer('routes-completed-layer')) maps.removeLayer('routes-completed-layer');
      }
    } catch (e) {}

    try {
      if (typeof maps.getSource === 'function') {
        if (maps.getSource('routes-source')) maps.removeSource('routes-source');
        if (maps.getSource('routes-completed-source')) maps.removeSource('routes-completed-source');
      }
    } catch (e) {}

    // Clear ETA prediction route and marker
    try {
      if (typeof maps.getLayer === 'function') {
        if (maps.getLayer('eta-prediction-route-line')) maps.removeLayer('eta-prediction-route-line');
        if (maps.getLayer('eta-prediction-route-glow')) maps.removeLayer('eta-prediction-route-glow');
      }
      if (typeof maps.getSource === 'function') {
        if (maps.getSource('eta-prediction-route')) maps.removeSource('eta-prediction-route');
      }
    } catch (e) {}
    const { etaDestinationMarkerRef, setEtaDestinationMarkerRef } = get();
    if (etaDestinationMarkerRef && typeof etaDestinationMarkerRef.remove === 'function') {
      try {
        etaDestinationMarkerRef.remove();
      } catch (e) {}
      setEtaDestinationMarkerRef(null);
    }

    try {
      if ((maps as any)._historyActivePopup) {
        (maps as any)._historyActivePopup.remove();
        (maps as any)._historyActivePopup = null;
      }
      (maps as any)._historyActivePopupLat = null;
      (maps as any)._historyActivePopupLng = null;
    } catch (e) {}

    safeRemove(routesRef);
    safeRemove(polylineRef);
    safeRemove(polylineAnimationRef);
    safeRemove(vesselAnimationMarkerRef);
    safeRemove(markersRouteRef);

    if (canvasLayer && Array.isArray(markersRouteRef) && markersRouteRef.length > 0) {
      for (let i = 0; i < markersRouteRef.length; i++) {
        try {
          canvasLayer?.removeMarker?.(markersRouteRef[i]);
        } catch (e) {}
      }
    }
    setMarkersRouteRef([]);
    setPolylineRef([]);
    setPolylineRouteData([]);
    setRoutsRef(null);
  },
  etaDestinationMarkerRef: null,
  setEtaDestinationMarkerRef: (ref) => set({ etaDestinationMarkerRef: ref }),
  etaOriginMarkerRef: null,
  setEtaOriginMarkerRef: (ref) => set({ etaOriginMarkerRef: ref }),
  cleanEtaPredictionRoute: () => {
    const { maps, etaDestinationMarkerRef, etaOriginMarkerRef } = get();
    if (etaDestinationMarkerRef && typeof etaDestinationMarkerRef.remove === 'function') {
      try {
        etaDestinationMarkerRef.remove();
      } catch (e) {}
      set({ etaDestinationMarkerRef: null });
    }
    if (etaOriginMarkerRef && typeof etaOriginMarkerRef.remove === 'function') {
      try {
        etaOriginMarkerRef.remove();
      } catch (e) {}
      set({ etaOriginMarkerRef: null });
    }
    if (maps && typeof maps.getLayer === 'function') {
      try {
        if (maps.getLayer('eta-prediction-route-line')) maps.removeLayer('eta-prediction-route-line');
        if (maps.getLayer('eta-prediction-route-glow')) maps.removeLayer('eta-prediction-route-glow');
        if (maps.getSource('eta-prediction-route')) maps.removeSource('eta-prediction-route');

        if (maps.getLayer('eta-history-sailed-line')) maps.removeLayer('eta-history-sailed-line');
        if (maps.getLayer('eta-history-sailed-glow')) maps.removeLayer('eta-history-sailed-glow');
        if (maps.getSource('eta-history-sailed-route')) maps.removeSource('eta-history-sailed-route');
      } catch (e) {}
    }
  },
  modalMinimizedVesselConfiguration: false,
  setModalMinimizedVesselConfiguration: (modalMinimizedVesselConfiguration) =>
    set(() => ({ modalMinimizedVesselConfiguration })),
  modalOpenVesselConfiguration: false,
  setModalOpenVesselConfiguration: (modalOpenVesselConfiguration) =>
    set(() => ({ modalOpenVesselConfiguration })),
  toggleModalOpenVesselConfiguration: () =>
    set((state) => ({ modalOpenVesselConfiguration: !state.modalOpenVesselConfiguration })),
  isMapsLayerOpen: false,
  setMapsLayerOpen: (isOpen) => set(() => ({ isMapsLayerOpen: isOpen })),
  toggleMapsLayerOpen: () => set((state) => ({ isMapsLayerOpen: !state.isMapsLayerOpen })),
  modalMinimizedMapsLayer: false,
  setModalMinimizedMapsLayer: (modalMinimizedMapsLayer) =>
    set(() => ({ modalMinimizedMapsLayer })),
}));

export default useMapsGLStore;
